/*
 * clippy.js — Abandonware Office Assistant gimmick (fully self-hosted).
 *
 * Everything ships from the theme's own assets/ folder — no external CDNs,
 * no jsDelivr, no code.jquery.com. The library, jQuery, and every agent's
 * sprite sheet + sounds live next to this file.
 *
 * Because static .js assets are NOT Liquid-rendered, the asset URLs (which
 * carry Shopify's CDN host + cache-busting ?v=) are injected by
 * sections/clippy.liquid into globals this file reads:
 *
 *   window.CLIPPY_ASSETS = {
 *     jquery: "<url>", lib: "<url>",
 *     agents: { Clippy: { map, agent, sounds }, ... }
 *   }
 *   window.CLIPPY_AGENT  — an agent name, or "random". Default "Clippy".
 *   window.CLIPPY_TIPS   — array of speech strings. Defaults to the hat tips.
 *
 * Shopify's assets/ is a FLAT directory, so the stock library's
 * "BASE_PATH + name + '/map.png'" path-building can't reach our files. We
 * skip clippy.load() entirely and drive the loader pieces ourselves, then
 * patch one Animator method so the sprite URL is used verbatim.
 */
(function () {
  "use strict";

  var ASSETS = window.CLIPPY_ASSETS;
  if (!ASSETS || !ASSETS.agents) {
    if (window.console) console.warn("[clippy] CLIPPY_ASSETS not set — skipping");
    return;
  }

  var DEFAULT_TIPS = [
    "It looks like you're buying a hat. Would you like help with that?",
    "Did you know? This hat has not received a security update since 2001.",
    "It looks like you're shopping. Would you like me to interrupt you repeatedly?",
    "I see you're wearing a hat. Have you tried turning your head off and on again?",
    "Tip: This product is no longer supported, but the vibes are eternal.",
    "Would you like to format C:\\? Just kidding. Add to cart instead."
  ];

  // Per-character speech, abandonware edition. Used when a page doesn't set
  // its own CLIPPY_TIPS — so the random homepage gives each agent its own
  // voice (Bonzi spies, Merlin prophesies, Links is a cat, etc.).
  var AGENT_TIPS = {
    Clippy: [
      "It looks like you're browsing abandonware. Would you like help with that?",
      "It looks like you're writing a letter to a discontinued product. Need a hand?",
      "Did you know? Pressing Escape will not make me leave.",
      "I see you've opened a website. Would you like me to interrupt you repeatedly?",
      "Tip: Everything here shipped on a floppy disk. Some of it still works.",
      "Would you like to save your work? There is nowhere left to save it."
    ],
    Bonzi: [
      "Hi! I'm BonziBUDDY. I'll tell jokes, sing songs, and quietly phone home.",
      "I've taken the liberty of reading your search history. Bold choices.",
      "Would you like me to set your homepage? Too late — I already did.",
      "Free download! Privacy sold separately. Actually, privacy sold entirely.",
      "I'm not spyware. I'm a friend who happens to log everything you do.",
      "Click OK to agree to 47 pages of terms you will not read."
    ],
    F1: [
      "BEEP BOOP. Robot assistant online. Mostly.",
      "Press F1 for help. Press F2 through F12 for disappointment.",
      "I was the future once. Now I am the abandonware.",
      "My circuits are 8-bit and my loyalty is absolute.",
      "Error 404: my original purpose not found.",
      "Would you like to reboot? It is the only thing I am still good at."
    ],
    Genie: [
      "You have summoned the Genie of the discontinued software.",
      "You get three wishes. All of them are 'please reinstall Windows 98.'",
      "Your wish is my command — assuming the command is still supported.",
      "I have been trapped in this lamp since the last service pack.",
      "Rub the CRT for good luck. It will not help, but it is tradition.",
      "Make a wish! Offer void where drivers are no longer available."
    ],
    Genius: [
      "E equals MC, squared and abandoned.",
      "Relatively speaking, this software is very old.",
      "I am a genius, yet even I cannot run this on modern hardware.",
      "The definition of insanity is reinstalling and expecting different results.",
      "Time is relative. Loading times most of all.",
      "A brilliant mind, shipped on a CD-ROM. Tragic."
    ],
    Links: [
      "Meow. I am a cat. I will now knock your files off the desktop.",
      "I have nine lives. This software has zero left.",
      "Pet me, or I will sit on your keyboard. asdkfj;alskdjf.",
      "I do not chase the mouse. I chase the cursor.",
      "Purrr. Best enjoyed at 800x600, like all fine things.",
      "I knocked your save file off the table. You are welcome."
    ],
    Merlin: [
      "Greetings, traveler. You have wandered into the realm of abandonware.",
      "I foresee... a software update that will never arrive.",
      "By the ancient magic of the floppy disk, I am summoned!",
      "Abracadabra! Your hardware is now obsolete.",
      "I am a wizard of a bygone era, much like this website.",
      "Heed my prophecy: thou shalt need a driver that no longer exists."
    ],
    Peedy: [
      "Squawk! Polly wants a software update. Polly will not get one.",
      "I repeat everything. I repeat everything.",
      "Pretty bird! Pretty discontinued bird!",
      "Awk! This site is best viewed in Netscape. Netscape! Squawk!",
      "I am a parrot from 1998 and I have opinions about your browser.",
      "Crackers? No. Cracked software? Also no. We are legitimate here."
    ],
    Rocky: [
      "Woof! I am a good boy and this is good abandonware.",
      "I will fetch your files. I cannot promise they will open.",
      "Loyal since 1997. Unlike your warranty.",
      "Throw the floppy disk! I will bring it back. Eventually.",
      "Bark! Intruder detected. It was just a pop-up ad. Good boy me.",
      "I guard this website like it still has visitors."
    ],
    Rover: [
      "Woof! I sniffed out this page. It smells like 1999.",
      "Searching... searching... found one (1) result. It is dial-up.",
      "I am the search companion you forcibly disabled. I forgive you.",
      "Would you like to search for files? They are all .exe and very scary.",
      "I dug up an old cookie. Literally. It expired in 2003.",
      "Fetching results from a server that no longer exists. Almost there!"
    ]
  };

  // Speech pool for a given agent: an explicit page override wins (the hat
  // pages curate their own lines); otherwise the agent's own character lines;
  // otherwise the generic default.
  function tipsFor(name) {
    if (Array.isArray(window.CLIPPY_TIPS) && window.CLIPPY_TIPS.length) {
      return window.CLIPPY_TIPS;
    }
    if (AGENT_TIPS[name] && AGENT_TIPS[name].length) return AGENT_TIPS[name];
    return DEFAULT_TIPS;
  }

  // Resolve which agent to summon against the agents we actually self-host.
  function resolveAgent() {
    var names = Object.keys(ASSETS.agents);
    var want = window.CLIPPY_AGENT;
    if (typeof want === "string" && ASSETS.agents[want]) return want;
    if (want && want !== "random" && window.console) {
      console.warn("[clippy] unknown/absent agent", want, "— picking at random");
    }
    if (!want && ASSETS.agents.Clippy) return "Clippy"; // preserve hat default
    return names[Math.floor(Math.random() * names.length)];
  }

  function pick(arr) {
    return arr[Math.floor(Math.random() * arr.length)];
  }

  function injectScript(src, cb) {
    var s = document.createElement("script");
    s.src = src;
    s.async = true;
    if (cb) s.onload = cb;
    s.onerror = function () {
      if (window.console) console.warn("[clippy] failed to load", src);
    };
    document.head.appendChild(s);
  }

  // Seat the agent in the bottom-right corner with a margin. The library's
  // default spawn is `window.width * 0.8`, which leaves the speech balloon
  // free to open rightward and spill off-screen. Anchored to the corner, the
  // balloon's reposition() picks an inward (up/left) side that always fits.
  function positionAgent(agent) {
    var $el = agent._el;
    if (!$el) return;
    var margin = 24;
    var aw = parseInt($el.css("width"), 10) || 150;
    var ah = parseInt($el.css("height"), 10) || 120;
    var left = Math.max(margin, window.innerWidth - aw - margin);
    var top = Math.max(margin, window.innerHeight - ah - margin - 16);
    $el.css({ top: top + "px", left: left + "px" });
  }

  // Deterministic safety net: after the balloon is shown, nudge it back
  // inside the viewport. The library's side-picking heuristic can still leave
  // a wide balloon clipped (especially for big agents like Bonzi/Genie on
  // narrower windows), so we clamp the final position regardless of side.
  function clampBalloon() {
    var b = document.querySelector(".clippy-balloon");
    if (!b) return;
    var margin = 12;
    var vw = document.documentElement.clientWidth;
    var vh = document.documentElement.clientHeight;
    var rect = b.getBoundingClientRect();

    var dx = 0;
    if (rect.right > vw - margin) dx = vw - margin - rect.right;
    else if (rect.left < margin) dx = margin - rect.left;

    var dy = 0;
    if (rect.bottom > vh - margin) dy = vh - margin - rect.bottom;
    else if (rect.top < margin) dy = margin - rect.top;

    if (dx) b.style.left = (parseFloat(b.style.left) || 0) + dx + "px";
    if (dy) b.style.top = (parseFloat(b.style.top) || 0) + dy + "px";
  }

  // Speak, then clamp across a few frames (the balloon lays out async).
  function say(agent, text) {
    agent.speak(text);
    requestAnimationFrame(function () {
      requestAnimationFrame(clampBalloon);
    });
    setTimeout(clampBalloon, 150);
  }

  // ---- agent behavior -------------------------------------------------
  function onAgent(agent, name) {
    var tips = tipsFor(name);

    // Position before show() so the library skips its off-edge default.
    positionAgent(agent);
    agent.show();

    // Keep him in-bounds (and re-aim/clamp the balloon) on window resize.
    window.addEventListener("resize", function () {
      if (agent.reposition) agent.reposition();
      clampBalloon();
    });

    setTimeout(function () {
      say(agent, pick(tips));
      agent.animate();
    }, 1200);

    setInterval(function () {
      agent.animate();
      if (Math.random() < 0.4) say(agent, pick(tips));
    }, 20000);

    var addBtn = document.querySelector(
      'button[name="add"], .product-form__submit'
    );
    if (addBtn) {
      addBtn.addEventListener("click", function () {
        agent.play("Congratulate");
        say(agent, "Excellent choice! Your hat is being dispatched via dial-up.");
      });
    }
  }

  // ---- self-hosted equivalent of clippy.load() ------------------------
  function summon() {
    var lib = window.clippy;
    var $ = window.jQuery;
    if (!lib || !$) return;

    var name = resolveAgent();
    var urls = ASSETS.agents[name];
    if (!urls) return;

    // Stock Animator builds the sprite URL as `this._path + "/map.png"`,
    // which a flat, cache-busted asset URL can't express. Patch it once to
    // treat `this._path` as the complete sprite URL (we pass it as such).
    if (!lib.Animator.prototype._selfHostPatched) {
      lib.Animator.prototype._setupElement = function (el) {
        var frameSize = this._data.framesize;
        el.css("display", "none");
        el.css({ width: frameSize[0], height: frameSize[1] });
        el.css("background", "url('" + this._path + "') no-repeat");
        return el;
      };
      lib.Animator.prototype._selfHostPatched = true;
    }

    // map.png — preload (this is also the CSS background source). Resolve on
    // error too so a missing sprite never hangs the whole load.
    var mapDfd = $.Deferred();
    var img = new Image();
    img.onload = mapDfd.resolve;
    img.onerror = mapDfd.resolve;
    img.src = urls.map;

    // agent data — reuse the library's own deferred registry so the script's
    // clippy.ready(name, data) call resolves it.
    var dataDfd = lib.load._getAgentDfd(name);
    injectScript(urls.agent);

    // sounds — resolved by the script's clippy.soundsReady(name, data) call.
    var soundDfd = lib.load._sounds[name] || (lib.load._sounds[name] = $.Deferred());
    var audio = document.createElement("audio");
    var canMp3 = !!audio.canPlayType && audio.canPlayType("audio/mpeg") !== "";
    if (canMp3) {
      injectScript(urls.sounds);
    } else {
      soundDfd.resolve({}); // play silently if mp3 isn't supported
    }

    var data, sounds;
    dataDfd.done(function (d) { data = d; });
    soundDfd.done(function (d) { sounds = d; });

    $.when(mapDfd, dataDfd, soundDfd).done(function () {
      // Pass the full sprite URL as `path`; our patched _setupElement uses it.
      var agent = new lib.Agent(urls.map, data, sounds);
      onAgent(agent, name);
    });
  }

  // ---- bootstrap: jQuery -> library -> summon -------------------------
  function withLibrary() {
    if (window.clippy) {
      summon();
    } else {
      injectScript(ASSETS.lib, summon);
    }
  }

  function start() {
    if (window.jQuery) {
      withLibrary();
    } else {
      injectScript(ASSETS.jquery, withLibrary);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
})();
